import { db } from '../firebase/config';
import { collection, getDocs, limit, orderBy, query } from 'firebase/firestore';

const updatesCol = collection(db, 'app_updates');
const VERSION_KEY = 'jogunbiz.app.version';

function isVersionNewer(server, local) {
  const sv = String(server || '').split('.').map(v => parseInt(v, 10) || 0);
  const lv = String(local || '').split('.').map(v => parseInt(v, 10) || 0);
  const len = Math.max(sv.length, lv.length);
  for (let i = 0; i < len; i++) {
    const s = sv[i] ?? 0;
    const l = lv[i] ?? 0;
    if (s > l) return true;
    if (s < l) return false;
  }
  return false;
}

async function fetchLatestUpdate() {
  const q = query(updatesCol, orderBy('createdAt', 'desc'), limit(1));
  const snap = await getDocs(q);
  if (snap.empty) return null;
  const data = snap.docs[0].data();
  return { version: data.version || '', content: data.content || '' };
}

export async function checkAppUpdate({ onUpdate }) {
  try {
    const latest = await fetchLatestUpdate();
    if (!latest || !latest.version) return;

    const localVersion = localStorage.getItem(VERSION_KEY);

    if (!localVersion) {
      localStorage.setItem(VERSION_KEY, latest.version);
      return;
    }

    if (isVersionNewer(latest.version, localVersion)) {
      localStorage.setItem(VERSION_KEY, latest.version);
      if (typeof onUpdate === 'function') {
        onUpdate(latest.content || '새 버전이 적용됩니다');
      }
      setTimeout(() => window.location.reload(), 1500);
    }
  } catch (err) {
    console.error('버전 체크 실패:', err);
  }
}
